import { render } from "./devDev.vue?vue&type=template&id=61c73696&scoped=true"
import script from "./devDev.vue?vue&type=script&lang=js"
export * from "./devDev.vue?vue&type=script&lang=js"

import "./devDev.vue?vue&type=style&index=0&id=61c73696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c73696"]])

export default __exports__